<template>
  <div class="article-page">
    <common-bar-container
      @login="auth"
      @logout="logout"
    ></common-bar-container>
    <article-container
      class="article-container"
      @auth="$emit('auth', arguments[0])"
    ></article-container>
    <footer-bar></footer-bar>
  </div>
</template>

<script>
import FooterBar from '@/components/FooterBar.vue'

export default {
  components: {
    CommonBarContainer: require('@/components/CommonPanelContainer.vue'),
    ArticleContainer: require('@/components/ArticleContainer.vue'),
    FooterBar
  },
  methods: {
    auth () {
      this.$emit('auth')
    },
    logout () {
      this.$emit('logout')
    }
  }
}
</script>

<style lang="sass" scoped>
.counters
  text-align: left

.article-wrapper
  height: calc(100% - 35px - 31px)
</style>



// WEBPACK FOOTER //
// Article.vue?ea8f4efa